<template>
  <div >
    <!-- <h1 class="title">{{ title }}</h1> -->
    <el-row>
      <el-col :span="18">
        <div class="block">
            <el-pagination
              @current-change="handleCurrentChange"
              :currentPage="page"
              :page-size="12"
              layout="prev, pager, next, jumper"
              :total="resData.total">
            </el-pagination>
        </div>
      </el-col>
      <el-col :span="6">
        <el-date-picker
              v-model="choose_date"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :change="haveChange1()"
              :picker-options="pickerOptions">
            </el-date-picker>
      </el-col>
    </el-row>
    <el-table :data="items"
    style="width: 100%; text-align: center;" fit
    :cell-style="{padding:'0'}"
    stripe>
      <el-table-column
      prop="vddb_title"
      label="VDDB Title"
      min-width="10%"
      align="center"
      ></el-table-column>
      <el-table-column
      prop="company"
      label="Company"
      min-width="10%"
      align="center"
      ></el-table-column>
      <el-table-column
      prop="matched_linking_sites"
      label="# of matched linking sites"
      min-width="10%"
      align="center"
      ></el-table-column>
      <el-table-column
      prop="matched_linking_urls"
      label="# of matched linking URLs"
      min-width="10%"
      align="center"
      ></el-table-column>
      <el-table-column
      prop="host_sites_with_outcome"
      label="# of host sites with outcome"
      min-width="10%"
      align="center"
      ></el-table-column>
      <el-table-column
      prop="infringing_host_urls"
      label="# of infringling host URLs"
      min-width="10%"
      align="center"
      ></el-table-column>
      <el-table-column
      min-width="10%"
      align="center"
      >
        <template slot="header">
          <el-row style="border: white;">
            <el-col :span="24">LSR Outcome</el-col>
            </el-col>
          </el-row>
        </template>
        <el-table-column
        prop="report"
        label="Report"
        min-width="10%"
        align="center"
        ></el-table-column>
        <el-table-column
        prop="takedown"
        label="Takedown"
        min-width="10%"
        align="center"
        ></el-table-column>
        <el-table-column
        prop="compliance"
        label="Compliance"
        min-width="10%"
        align="center"
        ></el-table-column>
      </el-table-column>




    </el-table>




  </div>
</template>

<script>
export default {
  name: 'Verfied_by_title',
  data () {
    return {
      title: 'Verfied_group_by_title page',
      page:1,
      items:[],
      resData:[],
      choose_date:'',
      start_time:0,
      end_time:0,
      pickerOptions: {
                shortcuts: [{
                  text: '最近一周',
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', [start, end]);
                  }
                }, {
                  text: '最近一个月',
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                    picker.$emit('pick', [start, end]);
                  }
                }, {
                  text: '最近三个月',
                  onClick(picker) {
                    const end = new Date();
                    const start = new Date();
                    start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                    picker.$emit('pick', [start, end]);
                  }
                }]
              },
    }
  },
  created(){
    this.get_items(1)
  },
  methods:{
    get_items:function(page){
      this.page = page
      this.$axios.get('https://www.fastmock.site/mock/8cb9fe9a48b19005c3c91eac13fb0376/api/api/title')
       .then(response => {
         this.resData = response.data
         this.items = this.resData.data;
         // console.log(this.resData)
      })
    },
    handleCurrentChange:function(val) {
            this.get_items(val)
            // console.log(this.s_search)
          },
    haveChange1:function(){
      try{
        this.start_time = this.choose_date[0].getTime()
        this.end_time = this.choose_date[1].getTime()
        console.log(this.start_time)
        console.log(this.end_time)
      }catch(e){
        console.log('')
      }

    }
  }


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .main{
    position: fixed;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/components/verfied_by_title.vue